import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentChooseTheCustomer from './ContentChooseTheCustomer';

const ChooseTheCustomer = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentChooseTheCustomer />
      <Bottom />
    </div>
  );
};

export default ChooseTheCustomer;
